import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import { serviceAreas } from '../../mocks/services';

export default function ServiceAreasPage() {
  return (
    <>
      <Header />
      <FloatingCTA />

      <section className="pt-32 pb-16 bg-brand-dark relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-5">
            <div className="h-px w-8 bg-brand-amber" />
            Service Areas
            <div className="h-px w-8 bg-brand-amber" />
          </div>
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-5">
            Chimney &amp; Duct Cleaning Serving All of Jacksonville, FL
          </h1>
          <p className="text-white/70 text-xl max-w-2xl mx-auto">BBM Services provides chimney cleaning, air duct cleaning, and dryer vent cleaning throughout the greater Jacksonville metro area.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Map */}
            <div className="lg:w-1/2">
              <div className="rounded-2xl overflow-hidden border border-stone-200 h-96 lg:h-full min-h-[400px]">
                <iframe
                  title="BBM Services Service Area Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d442972.1!2d-81.9554!3d30.3322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e5b716f1ceafeb%3A0xc4cd7d3896fcc7e3!2sJacksonville%2C%20FL!5e0!3m2!1sen!2sus!4v1"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            {/* Areas */}
            <div className="lg:w-1/2">
              <h2 className="font-serif text-3xl font-bold text-brand-dark mb-2">Communities We Serve</h2>
              <p className="text-brand-warm-gray mb-7">We serve the full Jacksonville metro area including Duval, St. Johns, Clay, and Nassau counties.</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
                {serviceAreas.map((area) => (
                  <div key={area} className="flex items-center gap-2 p-3 bg-stone-50 rounded-lg border border-stone-200 hover:border-brand-amber hover:bg-amber-50/50 transition-all">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-fill text-brand-amber text-sm" />
                    </div>
                    <span className="text-brand-dark text-sm font-medium">{area}</span>
                  </div>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-100 rounded-xl p-5">
                <h3 className="font-semibold text-brand-dark mb-2">Don't See Your Area?</h3>
                <p className="text-brand-warm-gray text-sm mb-4">We likely serve your community. Give us a call and we'll confirm coverage for your address.</p>
                <div className="flex gap-3">
                  <Link to="/contact" className="bg-brand-amber hover:bg-brand-amber-dark text-white font-semibold py-2.5 px-5 rounded-lg text-sm cursor-pointer whitespace-nowrap transition-all">Book Service</Link>
                  <a href="tel:+19045550191" className="border border-stone-300 hover:border-brand-amber text-brand-dark hover:text-brand-amber font-semibold py-2.5 px-5 rounded-lg text-sm cursor-pointer whitespace-nowrap transition-all">Call Us</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services by area */}
      <section className="py-16 bg-brand-muted">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl font-bold text-brand-dark text-center mb-10">Services Available in All Areas</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { title: 'Chimney Cleaning Jacksonville FL', desc: 'CSIA-certified chimney sweeps for all Jacksonville area homes — from Riverside to Nocatee and beyond.', slug: 'chimney-cleaning', icon: 'ri-fire-line' },
              { title: 'Air Duct Cleaning Jacksonville FL', desc: 'NADCA-certified duct cleaning for homes across Jacksonville, Orange Park, Ponte Vedra, and more.', slug: 'air-duct-cleaning', icon: 'ri-wind-line' },
              { title: 'Dryer Vent Cleaning Jacksonville FL', desc: 'Fast, affordable dryer vent cleaning across all Jacksonville communities. From $99. Same-week service.', slug: 'dryer-vent-cleaning', icon: 'ri-flashlight-line' },
            ].map((s) => (
              <Link key={s.slug} to={`/services/${s.slug}`} className="bg-white rounded-xl border border-stone-200 p-6 hover:border-brand-amber transition-all cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl mb-4">
                  <i className={`${s.icon} text-2xl text-brand-amber`} />
                </div>
                <h3 className="font-semibold text-brand-dark text-base mb-2">{s.title}</h3>
                <p className="text-brand-warm-gray text-sm leading-relaxed">{s.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
